import env from '@beam-australia/react-env';

export const isFileTooLargeToDownload = (size) => {
  const maxFileSize = parseInt(env('DATASET_ATTACHMENT_MAX_SIZE'), 10);
  if (maxFileSize) {
    return size > maxFileSize;
  }
  return false;
};

export const formatBytes = (bytes, si = true, dp = 2) => {
  if (!+bytes) return '0 Bytes';

  const k = si ? 1000 : 1024;
  const dm = dp < 0 ? 0 : dp;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
